import { WidgetInstance } from "friendly-challenge";

export default {
  init() {},
  finalize() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const requestType = urlParams.get("request-type");
    if (requestType) {
      $("#request-type option[value='" + requestType + "']").prop(
        "selected",
        true
      );
    }

    const element = document.querySelector("#friendly-challenge");
    const options = {
      doneCallback: doneCallback,
      startMode: "none",
    };
    const widget = new WidgetInstance(element, options);
    let captchaResult = false;

    function doneCallback(solution) {
      captchaResult = true;
      $('#captcha-error').removeClass('d-block');
    }

    $("#contact-form").validate({
      rules: {
        phone: {
          digits: true,
          minlength: 10,
          maxlength: 10,
        },
      },
      errorElement: "div",
      errorClass: "invalid-feedback",
      errorPlacement: function (error, element) {
        error.appendTo(element.closest(".form-group"));
      },
      highlight: function (element) {
        $(element).closest(".form-group").addClass("invalid");
        if (!captchaResult) {
          $('#captcha-error').addClass('d-block');
        }
      },
      unhighlight: function (element) {
        $(element).closest(".form-group").removeClass("invalid");
      },
      submitHandler: function (form) {
        if (!captchaResult) {
          $('#captcha-error').addClass('d-block');
        } else {
          submitForm();
        }
      },
    });

    function submitForm() {
      let $form = $("#contact-form");
      let $formData = new FormData($form.get(0));

      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: $formData,
        dataType: "JSON",
        processData: false,
        contentType: false,
        beforeSend: function () {
          $("#submit-contact-form").addClass("processing").prop('disabled', true);
        },
        complete: function (data) {
          setTimeout(function () {
            let timeOut = 0;
            if (
              (data.responseJSON && data.responseJSON.error) ||
              data.status !== 200
            ) {
              $("#submit-contact-form").addClass("fail");
              if (data.responseJSON.spam) {
                $(".alert-contact")
                  .removeClass("alert-success")
                  .addClass("alert-danger d-block")
                  .empty();
              } else {
                $(".alert-contact")
                  .removeClass("alert-success")
                  .addClass("alert-danger d-block")
                  .empty()
                  .append(data.responseJSON.error_message);
              }
              $(".alert-contact")
                .removeClass("alert-success")
                .addClass("alert-danger d-block")
                .empty()
                .append(data.responseJSON.error_message);
            } else {
              _paq.push([
                "trackEvent",
                "Contact",
                "Soumission réussie du formulaire de contact",
              ]);
              $form
                .find(
                  "input[name='name'], input[name='firstname'], input[name='email'], input[name='phone'], input[name='subject'], textarea[name='message'], input[name='attachment']"
                )
                .val("");
              $form.find("input[name='newsletter']").prop("checked", false);
              $form
                .find("select[name='request-type'] option:first")
                .prop("selected", true);
              $form.find("input[name='attachment']").trigger("change");
              $("#submit-contact-form").addClass("success");
              $(".alert-contact")
                .removeClass("alert-danger")
                .addClass("alert-success d-block")
                .empty()
                .append(
                  "Nous avons bien reçu votre message, nous tâcherons d'y répondre dans les plus brefs délais"
                );
              timeOut = 10000;
              setTimeout(function () {
                $(".alert-contact")
                  .removeClass("alert-success alert-danger d-block")
                  .addClass("d-none");
              }, timeOut);
            }
            setTimeout(function () {
              $("#submit-contact-form").removeClass("processing success fail").prop('disabled', false);
              captchaResult = false;
            }, timeOut);
            widget.reset();
          }, 500);
        },
        dataType: "json",
      });
    }
  },
};
